export const NewBadge = () => (
  <span className="ml-2 rounded bg-blue-700 px-1.5 py-0.5 text-[10px] font-bold uppercase text-white">New</span>
);
